import { render } from "./StaffAccountSettings.vue?vue&type=template&id=8681d3bc&ts=true"
import script from "./StaffAccountSettings.vue?vue&type=script&lang=ts"
export * from "./StaffAccountSettings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__